<template>
<div class="login-page">
    <!-- 背景特效-->
    <div class="layer bg" id="login" style="z-index:0"></div>
    <!-- 前置面板 -->
    <div style="height:100%;width:100%;z-index:1;">
        <!--居中区域-->
        <div style="height:100%;width:1409px;margin:0 auto;display:flex;flex-direction: column;">
            <div class="header">
                <div style="display:block" v-if="logoShow && logoInfo.type==0">
                    <img src="./image/logo.png" alt="logo">
                </div>
                <div v-else-if="logoShow" style="display:flex;flex-direction: row;align-items: center;">
                    <img src="./image/logo_icon.png" />
                    <div v-text="logoInfo.name" style="text-indent:5px;letter-spacing:3px;font-size:37px;color:#FFF;text-shadow:rgb(36 33 33) 1px 1px 2px"></div>
                </div>
            </div>
            <div style="flex:1;display:flex;flex-direction: row;justify-content: space-between;align-items: center;">
                <div class="logo-group">
                    <el-carousel indicator-position="outside" height="540px" arrow="never">
                        <el-carousel-item v-for="item in 4" :key="item" v-bind:class="'picBg'+item">
                        </el-carousel-item>
                    </el-carousel>
                </div>

                <div class="form-group">
                    <div class="loginArea">
                        <el-form ref="loginForm" label-width="100px" label-position="top" :rules="rules" :model="formLogin" size="default">
                            <div class="sysName" style="font-size:25px;">管理平台</div>
                            <el-form-item prop="username" label="登录账号">
                                <el-input type="text" v-model="formLogin.username" placeholder="用户名">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="password" label="登录密码">
                                <el-input type="password" v-model="formLogin.password" placeholder="密码">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="code">
                                <el-input type="text" v-model="formLogin.code" placeholder="验证码" v-enter="submit">
                                    <template slot="append">
                                        <img class="login-code" :src="codeUrl" @click="getCode">
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-button-group>
                                <el-button size="default" @click="submit" id="loginButton">登&nbsp;录</el-button>
                            </el-button-group>
                        </el-form>
                    </div>
                </div>
            </div>

            <!--底部-->
            <div class="footer flex-center">
                <div class="footer_info ">
                    <div>上海罕米信息科技有限公司&nbsp;&nbsp;·&nbsp;&nbsp;©2017~2037</div>&nbsp;&nbsp;&nbsp;&nbsp;
                    <div><img src="./image/police.webp" style="width:16px;position:relative;top:2px;" />&nbsp;&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2023017634号</a></div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
require("particles.js");
import config from "./config/default";
import {
    mapActions
} from "vuex";
import {
    getCodeImg,
    appConfig
} from "@/api/sys/login"

export default {
    computed: {
        logoInfo: function () {
            //正式配置
            let port = window.location.port;
            let appConfig = this.appConfig;
            let profile = appConfig.profile || 'prod';
            let parse = appConfig.parse || "port";
            let hostname =  window.location.hostname;
            let config = appConfig[profile];
            let env = profile == 'prod' ? "正式环境" : "非正式环境";
            console.log(
                `%c 路捷通-${env} %c v1.0.0 %c`,
                'background:#35495E; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;',
                `background:#3f86db; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff;`,
                'background:transparent'
            )
            if (port || hostname.indexOf(".com")==-1) {
                let title = config[port + ""] || config.def || "";
                console.log("当前系统", title)
                return {
                    type: title.indexOf("路捷通") >= 0 ? 0 : 1,
                    name: title
                }
            }else{
                let title = config[hostname] || config.def || "";
                console.log("当前系统", title)
                return {
                    type: title.indexOf("路捷通") >= 0 ? 0 : 1,
                    name: title
                }
            }
            return {
                type: 0,
                name: "路捷通"
            };
        },
    },
    data() {
        return {
            logoPath: "",
            dialogVisible: false,
            codeUrl: './image/login-code.png',
            users: [],
            // 表单
            formLogin: {
                username: "",
                password: "",
                uuid: "",
                code: ""
            },
            // 校验
            rules: {
                username: [{
                    required: true,
                    message: "请输入用户名",
                    trigger: "blur"
                }],
                password: [{
                    required: true,
                    message: "请输入密码",
                    trigger: "blur"
                }],
                code: [{
                    required: true,
                    message: "请输入验证码",
                    trigger: "blur"
                }]
            },
            appConfig: {
                "profile": "prod",
                "parse": "port",
                "prod": {
                    "def": "路捷通"
                }
            },
            logoShow: false
        };
    },
    mounted() {
        // 初始化例子插件
        particlesJS("login", config);
    },
    beforeDestroy() {
        // 销毁 particlesJS
        // thanks https://github.com/d2-projects/d2-admin/issues/65
        // ref https://github.com/VincentGarreau/particles.js/issues/63
        if (pJSDom && pJSDom.length > 0) {
            pJSDom[0].pJS.fn.vendors.destroypJS();
            pJSDom = [];
        }
    },
    created() {
        this.getCode()
        this.init();
    },
    methods: {
        ...mapActions("d2admin/account", ["login"]),
        init() {
            appConfig().then(res => {
                this.appConfig = JSON.parse(res || {});
            }).finally(() => {
                this.logoShow = true;
            });
        },
        /**
         * @description 接收选择一个用户快速登录的事件
         * @param {Object} user 用户信息
         */
        handleUserBtnClick(user) {
            this.formLogin.username = user.username;
            this.formLogin.password = user.password;
            this.submit();
        },
        getCode() {
            getCodeImg().then(response => {
                this.codeUrl = "data:image/gif;base64," + response.captcha;
                this.formLogin.uuid = response.uuid;
            });
        },
        /**
         * @description 提交表单
         */
        // 提交登录信息
        submit() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    // 登录
                    this.login({
                        vm: this,
                        username: this.formLogin.username,
                        password: this.formLogin.password,
                        verCode: this.formLogin.code,
                        uuid: this.formLogin.uuid
                    });
                } else {
                    if (!this.formLogin.username) {
                        this.$message.error("请输入登录账号");
                    } else if (!this.formLogin.password) {
                        this.$message.error("请输入登录密码");
                    } else if (!this.formLogin.code) {
                        this.$message.error("请填写验证码");
                    } else {
                        // 登录表单校验失败
                        this.$message.error("表单验证失败");
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
